<!--title -->
<app-modal-title
  [title]="'messages.deleteMessage' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div
  mat-dialog-content
  class="dialog-content tw-text-xl tw-text-center tw-mb-1"
>
  <!-- organizationName -->
  <h3 class="tw-font-extrabold tw-mb-[20px] dark:tw-text-gray-300">
    {{ organizationName }}
  </h3>

  <div class="tw-flex-center flex-column tw-w-[300px]">
    <div class="alert alert-danger tw-font-medium tw-text-base">
      <i class="fas fa-exclamation-circle text-alert tw-mx-1"></i>
      <span class="tw-font-bold">{{ "common.warning" | translate }} :</span>
      {{
        "pages.systemManagement.organizations.organizationDeleteConfirmDialog"
          | translate
      }}
    </div>
    <!-- confirmText title -->
    <div class="tw-flex flex-column tw-w-full">
      <span
        class="tw-font-medium tw-text-base tw-text-center tw-text-gray-700 dark:tw-text-gray-300"
        >{{ "messages.confirmText" | translate }}</span
      >
      <span
        class="tw-p-3 tw-text-base bg-light-primary tw-text-center tw-font-medium tw-mt-2 rounded"
        copyToClipboard
        >{{ randomNum }}</span
      >
    </div>
    <!-- input -->
    <div class="tw-w-full tw-mt-2">
      <input
        type="text"
        [maxlength]="4"
        max="4"
        class="form-control tw-mt-2"
        [(ngModel)]="typingText"
      />
    </div>

    <button
      [disabled]="+typingText != randomNum"
      mat-ripple
      class="btn tw-w-full tw-mt-5 tw-text-lg tw-font-bold tw-flex-center btn-danger"
      (click)="onConfirm('justOrganization')"
    >
      {{ "pages.systemManagement.organizations.justDeleteOrgan" | translate }}
      <!-- <i *ngIf="!config?.isConfirmDelete" class="fas fa-check-circle tw-text-base tw-mr-1"></i> -->
    </button>
    <button
      [disabled]="+typingText != randomNum"
      mat-ripple
      class="btn tw-w-full tw-mt-2 tw-text-lg tw-font-bold tw-flex-center btn-danger"
      (click)="onConfirm('organizationWihDescendantList')"
    >
      {{
        "pages.systemManagement.organizations.deleteOrganAndSubsets" | translate
      }}
      <!-- <i *ngIf="!config?.isConfirmDelete" class="fas fa-check-circle tw-text-base tw-mr-1"></i> -->
    </button>
    <button
      mat-ripple
      class="btn btn-secondary tw-w-full tw-text-lg tw-font-bold tw-mt-4"
      (click)="onClose()"
    >
      <span> {{ "common.cancel" | translate }}</span>
    </button>
  </div>
</div>
